export default [
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Requisite',
    },
    cell: {
      type: 'slot',
      name: 'requisite',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'User',
    },
    cell: {
      type: 'slot',
      name: 'user',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Link date',
    },
    cell: {
      type: 'slot',
      name: 'linkDate',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: '',
    },
    cell: {
      type: 'slot',
      name: 'controls',
    },
  },
];
